import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "paginate-items",
  class PaginateItems extends WYATTElement {
    connectedCallback() {
      this.anchors = this.querySelectorAll("a[href]");
      this.onClick = this.goToPage.bind(this);

      this.anchors.forEach((anchor) =>
        anchor.addEventListener("click", this.onClick),
      );
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.anchors.forEach((anchor) =>
        anchor.removeEventListener("click", this.onClick),
      );
    }

    goToPage(event) {
      const { currentTarget } = event;

      if (currentTarget.href) {
        const url = new URL(currentTarget.href, window.location.origin);
        this.publish(WYATT.PubSub.events.paginateTo, { url });
      }
      event.preventDefault();
    }
  },
);
